// Brand App Studio — the white label app sales page. It is a separate Lovable
// app, so the only way it knows who walked in is the query string: the creator's
// username when we have one, plus the door they came through.
//
// Signed out visitors (the public sales page) get no username param at all.

const APP_STUDIO_URL = 'https://brand-app-studio.lovable.app/';

export const buildAppStudioUrl = (username, source) => {
    const params = new URLSearchParams();
    if (username) params.set('username', username);
    if (source) params.set('source', source);
    const query = params.toString();
    return query ? `${APP_STUDIO_URL}?${query}` : APP_STUDIO_URL;
};

export const openAppStudio = (username, source) => {
    window.open(buildAppStudioUrl(username, source), '_blank', 'noopener,noreferrer');
};

export default buildAppStudioUrl;
